import { createSlice } from '@reduxjs/toolkit';

const courseSlice = createSlice({
  name: 'course',
  initialState: {
    courseId: '',
  },
  reducers: {
    setCourseId: (state, action) => {
      state.courseId = action.payload;
    },
    clearCourse: (state) => {
      state.courseId = '';
    },
  },
});

export const { setCourseId, clearCourse } = courseSlice.actions;
export default courseSlice.reducer;
